import angular from 'angular';
import {
  authorizationService, loaderService, orgDataService, userService
} from 'app/services';
import { alerts } from 'app/components/global';
import PasswordFormController from './password.controller';
import passwordFormDirective from './password.directive';
import autofocusDirective from './autofocus.directive';
import notContainsValidator from './notContains.validator';
import hasComplexPasswordValidator from './hasComplexPassword.validator';


export const routeConfigPassword = {
  template: require('./password.html'),
  controller: 'PasswordFormController',
  controllerAs: 'passwordVM',
};

export default angular.module('app.components.membership.passwordForm', [
  'ngMessages',
  alerts,
  authorizationService,
  userService,
  loaderService,
  orgDataService
])
  .directive('passwordForm', passwordFormDirective)
  .directive('autofocus', autofocusDirective)
  .directive('notContains', notContainsValidator)
  .directive('hasComplexPassword', hasComplexPasswordValidator)
  .controller('PasswordFormController', PasswordFormController)
  .name;

console.log('app.components.membership.passwordForm created');
